import { Button, ButtonProps } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import React, { FC, MouseEventHandler } from 'react';
import { useDispatch, useSelector, useStore } from 'react-redux';

import { TLocalesKeys as K } from '../../../../types';
import { logChatbotStartOver } from '../../../bi';
import { sendRestartChat } from '../../../common/api/sendRestartChat';
import { TRootState } from '../../../common/reducers';
import { chatActions } from '../../../common/reducers/chat';
import { selectIsLocked, selectRestartChatParameters } from '../../../common/selectors/chat';
import { selectIsEnabled } from '../../../common/selectors/header';
import { navigationControl } from '../../../util/navigationControl';

const selectors = (state: TRootState) => ({
  isEnabled: selectIsEnabled(state),
  isLocked: selectIsLocked(state),
  restartChatParameters: selectRestartChatParameters(state),
});

export const ResetButton: FC<ButtonProps> = (props) => {
  const { isEnabled, isLocked, restartChatParameters } = useSelector(selectors);
  const { t } = useTranslation();
  const store = useStore();
  const dispatch = useDispatch();

  const clickHandler: MouseEventHandler<HTMLElement> = (e) => {
    const state = store.getState();

    sendRestartChat(restartChatParameters); // TODO: add handling of fail
    dispatch(chatActions.reset());
    window.scroll(0, 0);
    navigationControl.unlock();

    logChatbotStartOver(state);

    e.stopPropagation();
  };

  if (!isEnabled) {
    return null;
  }

  return (
    <Button size="small" skin="inverted" onClick={isLocked ? undefined : clickHandler} {...props}>
      {t<K>('header_btn_label')}
    </Button>
  );
};
